import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">
            {aboutContent.title}
          </h2>
          <div className="space-y-4">
            {aboutContent.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}